import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { RouterOutletComponent } from './router-outlet/router-outlet.component';

/** Module that provides bot configuration core features independent of the
 * product offering (service ai, voice ai, etc).
 */
@NgModule({
  declarations: [RouterOutletComponent],
  imports: [CommonModule, RouterModule],
  exports: [RouterOutletComponent],
})
export class BotConfigCoreModule {}
